import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpContextToken,
  HttpContext,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const loaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const loaderService = inject(LoaderService);

  // this is used in messages module to prevent showing loader when update status for messages
  // please don't remove it
  if (req.headers.get('X-Ignore-Loader') === 'true') {
    return next(req.clone({ headers: req.headers.delete('X-Ignore-Loader') }));
  }

  if (!req.context.get(SKIP_LOADER)) {
    loaderService.show();
  }

  return next(req).pipe(
    catchError(error => {
      loaderService.hide();
      throw error;
    }),
    finalize(() => {
      loaderService.hide();
    })
  );
};

export const skipLoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    context: new HttpContext().set(SKIP_LOADER, true),
  });

  return next(modifiedReq);
};
